import { Component, OnDestroy, OnInit } from "@angular/core";
import { GridDataResult } from "@progress/kendo-angular-grid";
import { CompositeFilterDescriptor, process } from "@progress/kendo-data-query";
import { BehaviorSubject } from "rxjs";
import { isNullOrWhiteSpace } from "src/app/interfaces/string";
import { NotificationFacade } from "src/app/notifications/services/notification.facade";
import { TemplateFacade } from "src/app/services/template.facade";
import { SubSink } from "subsink";
import { ICirculationTemplate } from "../../interfaces";
import { LogClass, Logger } from "../../logger";
import { NavigationService } from "../../services";

@Component({
    selector: "circ-my-templates",
    templateUrl: "./my-templates.component.html",
    styleUrls: ["./my-templates.component.scss"],
    standalone: false
})
@LogClass({ source: "MyTemplatesComponent" })
export class MyTemplatesComponent implements OnInit, OnDestroy {
  public empty = true;
  public loading = true;
  public templates: ICirculationTemplate[] = [];
  private filterValue: string = null;
  private logger: Logger;
  private subscriptions = new SubSink();
  public gridView$ = new BehaviorSubject<GridDataResult>(null);

  constructor(
    private templateFacade: TemplateFacade,
    private navigate: NavigationService,
    private notification: NotificationFacade
  ) {
    this.logger.debug("ctor");
  }

  public cellClickHandler({
    dataItem
  }: {
    dataItem: ICirculationTemplate;
  }): void {
    this.navigate.toTemplate(dataItem.id);
  }

  private loadGridView() {
    if (!this.templates) {
      this.logger.info("Data is null");
      this.gridView$.next(null);
      return;
    }

    this.gridView$.next(
      process(this.templates, {
        filter: this.getFilter(this.filterValue)
      })
    );
  }

  private getFilter(value: string): CompositeFilterDescriptor {
    if (isNullOrWhiteSpace(value)) {
      return null;
    }

    return {
      logic: "or",
      filters: [
        {
          field: "title",
          operator: "contains",
          value: value
        }
      ]
    };
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public ngOnInit(): void {
    this.logger.info("init");
    this.refreshTable();
  }

  public onFilter(input: string): void {
    this.filterValue = input;
    this.loadGridView();
  }

  private refreshTable() {
    this.subscriptions.sink = this.templateFacade.getMyTemplates().subscribe({
      next: (t) => {
        this.logger.info("loaded " + t.length + " templates.");
        this.loading = false;
        this.empty = t.length < 1;
        this.templates = t;
        this.loadGridView();
      },
      error: (err) => {
        this.loading = false;
        this.notification.showError(
          "Error while loading templates. Please ask your Administrator for help! " +
            err.error.message
        );
      }
    });
  }
}
